import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { IGetRatedOrderResponse } from '../models/rated-order.model';
import { lastValueFrom, Observable } from 'rxjs';
import { IGetOrderOnProgressResponse } from '@models/order.model';
import { AsHttpParams } from '@models/AsHttpParams.model';
import { CancelationPayload, ICancelMotivesResponse } from '@models/cancel-motive.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private URL: string = environment.rootUrl;
  private URL_LAMBDA: string = environment.lambdaUrl;
  public refreshHome$ = new EventEmitter<boolean>();

  constructor(
    private http: HttpClient
  ) { }

  public onSettingOrder(order: any, uuid: string): Promise<any> {
    try {
      return this.http.post(`${this.URL}/orders?uuid=${uuid}`, order).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onGettingOrders(dateStart: string, dateEnd: string, canceled: string, page: number, limit: number): Promise<any> {
    try {
      return this.http.get(`${this.URL}/orders/clients?date_start=${dateStart}&date_end=${dateEnd}&show_canceled=${canceled}&page=${page}&limit=${limit}`).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onGettingOrdersOnProgress(): Observable<IGetOrderOnProgressResponse> {
    return this.http.get<IGetOrderOnProgressResponse>(`${this.URL}/orders/clients/progress`);
  }

  public onGettingOrder(id: string): Promise<any> {
    try {
      return this.http.get(`${this.URL}/orders/${id}`).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public onGettingOrderObs(id: string): Observable<any> {
    return this.http.get(`${this.URL}/orders/${id}`);
  }

  public onAddingTip(tip: any): Promise<any> {
    return this.http.post(`${this.URL}/cart/pre-checkout/tips`, tip).toPromise();
  }

  public onAddingDiscountPoints(discount: any): Promise<any> {
    return lastValueFrom(this.http.post(`${this.URL}/cart/pre-checkout/discounts`, discount));
  }

  public async rateOrder(id: string, data: any): Promise<any> {
    return this.http.post(`${this.URL}/orders/${id}/rate`, data).toPromise();
  }

  public async cancelOrder(order_id: string, payload: CancelationPayload): Promise<any> {
    return this.http.put(`${this.URL}/orders/client/cancel/${order_id}`, payload).toPromise();
  }

  public async sendDeliveryNote(order_id: string, notes: string): Promise<any> {
    return this.http.post(`${this.URL}/orders/${order_id}/delivery-notes`, { notes }).toPromise();
  }

  public getRatedOrder(storeId: number): Observable<IGetRatedOrderResponse> {
    return this.http.get<IGetRatedOrderResponse>(`${this.URL_LAMBDA}/get-rated-order?branch=${storeId}`);
  }

  public getCancelMotives(orderType: string): Observable<ICancelMotivesResponse> {
    const params: AsHttpParams = {
      orderType: orderType,
    };
    return this.http.get<ICancelMotivesResponse>(`${this.URL}/orders/client/cancel/motives`, { params });
  }

}
